import React from 'react';

export const About: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <h1 className="text-6xl font-display font-normal text-charcoal-900">
        Elevation
      </h1>
    </div>
  );
};
